import Store from '../store/Store';

/**
 * Util to get mailbox PUID of organizer.
 */
export default function getMailboxPuid(): string {
    return Store.bookingMailboxPuid;
}
